module.exports = __webpack_public_path__ + "img/sell_puzzle.1d68d78d.svg";